/**
 * Orders tab
 */
export const orders = {

  roleId: {
    fo: '8dab2f2a-2866-4527-9b3d-d2237d8d24c8',
    blueTeam: '8dab2f2a-2866-4527-9b3d-d2237d8d24a7',
    estimator: '7dab2f2a-2866-4527-9b3d-d2237d8d24c7',
    qca: '8dab2f2a-2866-4527-9b3d-d2237d8d24c9',
    owner: '8dab2f2a-2866-4527-9b3d-d2237d8d24c7'

  },
  /** Schedule booking */
  status: {
    Available: "Available",
    Allocated: "Allocated",
    Accepted: "Accepted",
    Completed: "Completed",
    Scheduling: "Scheduling",
    Scheduled: "Scheduled",
    "In Progress": "In Progress",
    Declined: "Declined"
  },
  displayBookstatus: {
    Available: "Available",
    Allocated: "Allocated",
    Accepted: "Accepted",
    Completed: "Job Completed",
    Scheduling: "Scheduling in Process",
    Scheduled: "Customer is Scheduled",
    "In Progress": "Work in Progress",
    Declined: "Declined"
  },
  workRequested: 'Work Requested',
};
export const role = {
  fo: 'FO',
  estimator: 'Estimator',
  qca: 'QCA',
  blueTeam: 'Blue Team',
  roleTitle: "Role",
  uc: "UC",
  market: "Market",
  company: "Company",
  office: "Office"
}
export const displayValues = {
  operations: "Operations",
  bug: "Submit a Bug",
  reports: "Reports",
  autoResDb: "Auto Responder DB",
  auditLog: "S.E audit log",
  searchOldSe: "Search Old S.E",
  calender: "Calender",
  kpi: "KPI",
  team: "Team Users & Permissions",
  solutionDescription: "View or Edit DB",
  configuration: "Configuration",
  refreshOrders: "Refresh Orders",
  marketCompanyAffiliateBtn: "Market/ Company/ Affiliate Database",
  enterCRM: "Enter CRM",
  histKpis: "History KPI's",
  banner: "Banner reviews",
  marketReports: "Market Reports",
  copiedSuccess: 'Copied to clipboard',
  copiedFailed: 'Copy failed. Please try again!',
  success: 'success',
  failed: 'failed',
  solutionDes: {
    title: "ADD NEW DATABASE ITEM",
    keyword: "Keyword",
    solution: "Solution",
    cost: "Cost",
    drag: 'Drag',
    solutionEstimateEnteredHere: "Create a new solution estimate",
    costOption: "Cost drop down option",
    keyPrimCategory: "Keyword Primary Category",
    keyPhrase: "Keyword Phrase",
    Key1: "Keyword 1",
    key2: "Keyword 2",
    key3: "Keyword 3",
    key4: "Keyword 4",
    primaryCategory: "Primary Category",
    subcategory: "Select SubCategory",
    subcate: "SubCategory",
    irl: "Internal Resource Links",
    submitBtnText: "ADD/SAVE New DB ITEM",
    auditLOG: "SE Database audit log",
    viewEstimate: "VIEW TABLE",
    openAndViewCurrentDBITem: "OPEN AND VIEW / EDIT CURRENT DATABASE",
    updateDescription: "Update Solution",
    update: "COMPLETE EDIT TO DB",
    close: "CLOSE",
    noList: "No solution database item found",
    noSearchFoundAndSuggesstion: 'No matches found. Here are our suggestions..',
    beforeSearch: "Please fill any field to search",
    costOptions: {
      tm: 'T&M',
      manual: 'Manual Entry',
      Flat: 'Flat Rate',
      foot: 'by the foot'
    },
    tableColumn: {
      primaryCategory: "Primary",
      keyword: "Keyword",
      solution: "Solution",
      cost: "Cost",
      costOption: "Cost Option",
      keyPhrase: "KW Phrase",
      subCategory: "Sub",
      Key1: "KW 1",
      key2: "KW 2",
      key3: "KW 3",
      key4: "KW 4",
      link: "IRL",
      edit: "Edit",
      SE: 'Select & Edit',
      select: 'Select Solution',
      editThisSolutionInDB: "Edit Solution",
      delete: "Delete"
    },
    searchSolution: {
      searchTabTitle: "Keyword Search Criteria",
      searchTitle: "Database Search For Solution ",
      searchOptionsTitle: "Solution Estimate Options",
      seacrchDatabaseButton: "SEARCH",
      reset: 'Reset',
    }
  },
  manageRef: {
    head: "Manage references",
    detailTitle: "Manage references",
    tabs: {
      first: "Companies we serve",
      second: "Testimonial"
    },
    companies: {
      label: "Choose company logo we serve",
      uploadText: " Browse company logo",
      submitBtnText: "Submit",
      clearBtnText: "Clear",
      selectedFileName: "Selected file name(s) are"
    },
    testimonials: {
      label: "Choose your picture",
      uploadText: " Browse your picture",
      selectedFileName: "Selected file",
      quotes: "Enter your quotes",
      quotesPlaceHolder: "Quotes"
    },
    noList: "No list",
    delete: "Delete",
    deleteConfirm: "Are you sure you want to remove ?",
    deleteHead: "Confirm",
    deleteOk: "Yes",
    deleteCancel: "Cancel"
  },
  addNew: "Add new order",
  archivedHead: "Archived orders",
  customerToggleRequest: "Requested work",
  pros: "Pros",
  bizDev: "Biz Dev",
  solutionEstimates: "Solution Estimates",
  blueRecrewt: "Blue ReCrewt",
  user: "User Info",
  userHead: "Pro User Info",
  noProUser: "No pro user",
  payment: "Payment Info",
  invite: "Invite Pro",
  reviews: "Reviews",
  reviewsHead: "Pro's Reviews",
  uploadDocument: "Documents",
  bgCheck: "Background Check",
  license: "License",
  id: "Id Proof",
  insurance: "Insurance Certificate",
  view: "View",

  bottomHead: "Marketing",
  promoCode: "Promotion Codes",
  eblast: "Send eBlast",
  webinar: "Webinar Sign up List",
  fb: "Post to Facebook",
  toYoutube: "Upload to YouTube",
  toSite: "Upload video to site",

  liveOrder: "spekwo Live Order Feed",
  tableColumn: {
    name: "Client Name",
    address: "Property Address",
    order: "Product Ordered",
    date: "Order Date & Time",
    dueDate: "Due Date & Time",
    status: "Status",
    view: "Edit Solution Estimate",
    orderDetails: "Order Details",
    reqWork: "Requested work",
    whatToDo: "Work On S.E",
    whatToDo1: "Completed S.E",
    assign: "Work Claimed",
    toAssign: "pro-work",
    afterAssign: "Assigned",
    ordersrequested: "Orders Requested For",
    archive: "Archive",
    edit: 'Edit',
    orderInfo: "The Order",
    proJobDetails: 'Pro Job Details',
    firmData: "Firm Data"
  },
  archiveBtnText: "Archive orders",
  archiveHeaderText: "Archived orders",
  unArchiveBtnText: "Un archived order",
  orderDetails: "Order Details",
  orderDetailsColumn: {
    customerName: "Customer Name",
    agentType: "Agent Type",
    agent: "Agent Name",
    agentEmail: "Agent Email",
    contact: "Contact info of Agent",
    propertyAdd: "Subject Property Address",
    product: "Product Ordered",
    specificItems: "Specific Items Requested",
    dueDate: "Due Date",
    clientRole: "Client Role",
    clientName: "Buyer or Seller Name",
    addEmail: "Additional Email to send S.E.",
    payment: "Payment",
    unarchive: "Un archive",
    edit: 'Edit',
  },
  customerToggleRequestHeaderText: "Requested work",
  customerToggleRequestColumn: {
    orderId: "Order Id",
    scheduleRequestDate: "Schedule Completion Date",
    contactName: "Contact Name",
    contactEmail: "Contact Email",
    contactPhone: "Contact Phone",
    additionalShare: "Additional Share",
    propertyAddress: "Property Address",
    agentName: "Agent Name ",
    detailsButton: "Details",
    insReportId: "Report Id",
  },
  DetailDialogLabelsName: {
    details: "Details",
    orderId: "Order Id",
    address: "Address",
    agentName: "Agent Name",
  },

  walkArea: "Areas to Inspect",
  walkAreaAdditional: "Additional items to Inspect",
  spekCall: "Available categories",
  noPdf: "No pdf file uploaded",
  paidAt: "Paid at time of order",
  downloadInvoice: "Download/Open Invoice",
  downloadReceipt: "Recepit Link",
  stripeInvoice: "Stripe invoice to customer",
  open: "AWAITING PAYMENT",
  paid: "CLIENT PAID",
  amountPopupLabel: "Please ensure final amount to send invoice",
  amountSubmitBtn: "Send Invoice",
  amountCancelBtn: "Close",
  emailPopupContent: "Email id the link was sent to is",
  noInvoiceEmail: "No specify email given. Used billing email",
  videoColumn: {
    title: "Title",
    desc: "Description",
    video: "Video",
    tags: "Tags"
  },
  noVideo: "No video uploaded",
  uploadVideo: "Upload video to Youtube",
  titleReq: "Title is required!",
  descReq: "Description is required!",
  browse: "Browse",
  upload: "Upload",
  clear: "Clear file",
  uploading: "Uploading...",

  /**Define folder name from backend where uploading document stored */
  bgCheckFolder: "bgCheck",
  licenseFolder: "license",
  idFolder: "Id",
  insuranceFolder: "insurance",
  notes: "Is there anything more you want as to know when creating your quote?",
  contactName: "Contact Name",
  contactEmail: "Contact Email",
  contactPhone: "Contact phone",
  projectHighlight: "Highlights/Overview of work needed to get house on market?",
  reviewWork: "Who will be us out there to review the needed work?",
  homeMarket: "When do you hope to put the home on market?",
  specificItemNumbers: "Item numbers clients has entered specific item numbers with notes",
  permissions: "Permissions",
  noData: "The client did not enter the information at the time of the order"
};

export const toolTip = {
  menu: "click to open sidebar",
  manualUpload: "Click to upload Home Inspection file",
  addNew: "Click to add single row",
  addMore: "Click to add 10 rows",
  clearRow: "Click to clear a form data",
  drag: "Drag me",
  remove: "Remove entry",
  openImg: "Click to view image",
  addSubCate: "Click to add subcategory fo this category",
  uploadVideo: "Click to upload new video",
  homeInsReport: "Click to view home inspetcion report",
  quoteImages: "Click to view Quote Images",
  signImages: "Click to view Sign Image",
  ddra: "Click to view DDRA report",
  uniqueReport: "Click to view Unique report",
  preListPictures: "Click to view preList Pictures",
  printScheduling: 'Click to view Scheduling Info',
  supportingReport: "Click to view Supporting Report",
  auditLogReport: "Click to view audit log",

  addSolution: "Click to add solution to database",
  viewEstimate: "Click to view cost estimation table",

  // request work page
  approveSolutionEstimate: "Click to view Approve Solution Estimate",
  proSolutionEstimate: "Click to view Pro Solution Estimate",
  supportingInfo: "Click to view supporting Notes",
  auditType: "Audit Logs"
};



/**
-----schedulerequest-----
    Client Reviewed
    Allocated
    Accepted
    Completed

-----schedulebooking-----
    Available
    Allocated
    Accepted
*/

export const editOrders = {
  title: 'Order Details Edit',
  requireds: {
    emailRequired: 'Email Required',
    addressRequired: 'Address Required',
    cityRequired: 'City Required',
    stateRequired: 'State Required',
    postCodeRequired: 'Pincode Required',
    custNameRequired: 'Customer Name Required',
    agentNameRequired: 'Agent Name required',
    agentEmailRequired: 'Agent Email required',
    agentPhoneRequired: 'Agent Phone required',
    additionalEmailRequired: 'Additial Email To S.E Required',
    clientNameRequired: 'Client Name Required',
    clientRoleRequired: 'Client Role Required',
    agentTypeRequired: 'Agent Type Required',
  },
  save: 'Save',
  placeHolder: {
    email: 'Email',
    address: 'Address',
    city: 'City',
    state: 'State',
    postcode: 'Pincode',
    customerName: 'Customer Name',
    agentName: 'Agent Name',
    agentEmail: 'Agent Email',
    agentPhone: 'Agent Phone',
    agentType: 'Agent Type',
    clientName: 'Client Name',
    clientRole: 'Client Role',
    additialEmailToSe: 'Additional Email To S.E',
  }
}
export const states = [
  { viewValue: 'Alabama', value: 'Alabama' },
  { viewValue: 'Alaska', value: 'Alaska' },
  { viewValue: 'Arizona', value: 'Arizona' },
  { viewValue: 'Arkansas', value: 'Arkansas' },
  { viewValue: 'California', value: 'California' },
  { viewValue: 'Colorado', value: 'Colorado' },
  { viewValue: 'Connecticut', value: 'Connecticut' },
  { viewValue: 'Delaware', value: 'Delaware' },
  { viewValue: 'Florida', value: 'Florida' },
  { viewValue: 'Georgia', value: 'Georgia' },
  { viewValue: 'Hawaii', value: 'Hawaii' },
  { viewValue: 'Idaho', value: 'Idaho' },
  { viewValue: 'Illinois', value: 'Illinois' },
  { viewValue: 'Indiana', value: 'Indiana' },
  { viewValue: 'Iowa', value: 'Iowa' },
  { viewValue: 'Kansas', value: 'Kansas' },
  { viewValue: 'Kentucky', value: 'Kentucky' },
  { viewValue: 'Louisiana', value: 'Louisiana' },
  { viewValue: 'Maine', value: 'Maine' },
  { viewValue: 'Maryland', value: 'Maryland' },
  { viewValue: 'Massachusetts', value: 'Massachusetts' },
  { viewValue: 'Michigan', value: 'Michigan' },
  { viewValue: 'Minnesota', value: 'Minnesota' },
  { viewValue: 'Mississippi', value: 'Mississippi' },
  { viewValue: 'Missouri', value: 'Missouri' },
  { viewValue: 'Montana', value: 'Montana' },
  { viewValue: 'Nebraska', value: 'Nebraska' },
  { viewValue: 'Nevada', value: 'Nevada' },
  { viewValue: 'New Hampshire', value: 'New Hampshire' },
  { viewValue: 'New Jersey', value: 'New Jersey' },
  { viewValue: 'New Mexico', value: 'New Mexico' },
  { viewValue: 'New York', value: 'New York' },
  { viewValue: 'North Carolina', value: 'North Carolina' },
  { viewValue: 'North Dakota', value: 'North Dakota' },
  { viewValue: 'Ohio', value: 'Ohio' },
  { viewValue: 'Oklahoma', value: 'Oklahoma' },
  { viewValue: 'Oregon', value: 'Oregon' },
  { viewValue: 'Pennsylvania', value: 'Pennsylvania' },
  { viewValue: 'Rhode Island', value: 'Rhode Island' },
  { viewValue: 'South Carolina', value: 'South Carolina' },
  { viewValue: 'South Dakota', value: 'South Dakota' },
  { viewValue: 'Tennessee', value: 'Tennessee' },
  { viewValue: 'Texas', value: 'Texas' },
  { viewValue: 'Utah', value: 'Utah' },
  { viewValue: 'Vermont', value: 'Vermont' },
  { viewValue: 'Virginia', value: 'Virginia' },
  { viewValue: 'Washington', value: 'Washington' },
  { viewValue: 'West Virginia', value: 'West Virginia' },
  { viewValue: 'Wisconsin', value: 'Wisconsin' },
  { viewValue: 'Wyoming', value: 'Wyoming' },
];
export const proJobConst = {
  tableColumn: {
    id: 'ID',
    description: 'DECRIPTION',
    solution: 'SOLUTION',
    pictures: 'PICTURES',
    shoppingMaterial: 'SHOPPING MATERIAL',
    suppliesMaterial: 'SUPPLIES MATERIAL',
    uploadedPics: 'Uploaded Pics',
  },
  quoteImages: 'View Quote Images',
  signImage: 'View Sign Images',
  noSolution: 'No Solution Created Yet',
  proSolution: 'Proposed Solution',
  descIssue: 'Description Of Issue',
  costToClient: 'Quoted Cost to Client',
  signDate: 'sign Date',
  closeProject: ' Close Project',
};

export const parentMenuItemsConfig = {
  solEstimate: "work_on_solution_estimate",
  solEstimate1: "work_on_solution_estimate_1",
  operations: "operations",
  bizDev: "biz_dev",
  blueRecrewt: "blue_recrewt",
  solutionEst: "solution_estimates",
  seAuditLog: "se_audit_log",
  userPermEdit: "user_permission_edit",
  orderMenu: "order_table_details",
  users: "users_list"
};

export const menuItems = {
  solEstimate: "solution_estimate",
  orderDetails: "order_details",
  requestWork: "requested_work",
  viewFinal: "view_final",

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/utils/e-commerce/orders.ts